import { useTranslation } from "react-i18next";

export function AppFooter() {
    const { t } = useTranslation();
    return (
        <footer className="w-full">
            <div className="flex flex-col items-center justify-center px-6 py-2">
                <div className="flex items-center gap-2">
                    <p className="text-[10px] text-neutral-400">
                        {t('FOOTER_DISCLAIMER')}
                    </p>
                    {/* <HelpCircle className="size-5 text-neutral-400" /> */}
                </div>
            </div>
        </footer>
    );
} 